import { applyPalette, clearPalette, paletteFromHex } from '@sitewise/ui';
import { create } from 'zustand';


export interface BrandingSnapshot {
  orgName: string;
  orgSlug: string;
  primaryColorHex: string | null;
  logoUrl: string | null;
}

interface BrandingState {
  snapshot: BrandingSnapshot | null;
  apply(snapshot: BrandingSnapshot): void;
  clear(): void;
}

/**
 * Holds the current org's branding snapshot and side-effects the document
 * root's CSS variables when it changes. The platform's super-admin shell
 * never reads this store — its accent comes from `--color-admin-accent`.
 */
export const useBrandingStore = create<BrandingState>((set) => ({
  snapshot: null,
  apply: (snapshot) => {
    if (typeof document !== 'undefined') {
      const root = document.documentElement;
      if (snapshot.primaryColorHex) {
        const palette = paletteFromHex(snapshot.primaryColorHex);
        if (palette) applyPalette(root, palette);
      } else {
        clearPalette(root);
      }
    }
    set({ snapshot });
  },
  clear: () => {
    if (typeof document !== 'undefined') clearPalette(document.documentElement);
    set({ snapshot: null });
  },
}));
